import { prepareApiHeaders } from '@/features/utils';

interface ClientInfo {
  browser?: string;
  screenSize?: string;
  devicePixelRatio?: number;
}

interface MetricOptions {
  clientInfo?: ClientInfo;
  attributes?: Record<string, unknown>;
  type?: 'histogram' | 'counter' | 'gauge';
}

interface LoginState {
  tokenId?: string;
  user?: string;
}

export class MetricEmitter {
  private loginState: LoginState;

  constructor(loginState: LoginState) {
    this.loginState = loginState;
  }

  emit(
    metricName: string,
    value: number,
    options: MetricOptions = {}
  ): Promise<Response> {
    const { clientInfo = {}, attributes = {}, type = 'histogram' } = options;

    const defaultClientInfo: ClientInfo = {
      browser: navigator.userAgent,
      screenSize: `${window.innerWidth}x${window.innerHeight}`,
      devicePixelRatio: window.devicePixelRatio,
    };

    const headers = prepareApiHeaders(new Headers(), {
      getState: () => ({ login: this.loginState }),
    });

    headers.set('Content-Type', 'application/json');

    return fetch(`/v1/metrics/`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        metric_name: metricName,
        value,
        type,
        clientInfo: { ...defaultClientInfo, ...clientInfo },
        attributes,
      }),
      credentials: 'include',
    });
  }
}
